export const submitTextMap: Record<number, string> = {
  1: "Next",
  2: "Next",
  3: "Allocate",
};
